import type { ReactNode } from 'react'

interface ScoreSliderProps {
  /** 0-100, o -1 = "sin definir" (no tocado todavia). */
  value: number
  onChange: (value: number) => void
  ariaLabel?: string
  /** Rotulo del extremo izquierdo (valor 0). */
  leftLabel?: string
  /** Rotulo del extremo derecho (valor 100). */
  rightLabel?: string
}

/** Slider 0-100 equivalente al ScoreSlider de la app. -1 => sin definir. */
export function ScoreSlider({
  value,
  onChange,
  ariaLabel,
  leftLabel,
  rightLabel,
}: ScoreSliderProps): ReactNode {
  const defined = typeof value === 'number' && value >= 0
  // Mientras no este definido, el slider se ve centrado en 50 pero no persiste
  // dato hasta que el usuario lo mueve (paridad con la app).
  const displayValue = defined ? value : 50

  return (
    <div className="flex flex-col gap-1.5">
      <input
        type="range"
        min={0}
        max={100}
        step={1}
        value={displayValue}
        aria-label={ariaLabel}
        onChange={(e) => onChange(Number(e.target.value))}
        className="h-2 w-full cursor-pointer appearance-none rounded-full bg-muted accent-primary"
      />
      {/* Rotulos de extremos con el valor centrado entre ellos. grid-cols-3
          garantiza que el numero quede centrado sin importar el largo de los
          rotulos. */}
      <div className="grid grid-cols-3 items-center text-xs text-muted-foreground">
        <span className="text-left">{leftLabel}</span>
        <span className="text-center tabular-nums">
          {defined ? `${value}%` : 'Sin definir'}
        </span>
        <span className="text-right">{rightLabel}</span>
      </div>
      {defined ? (
        <button
          type="button"
          onClick={() => onChange(-1)}
          className="self-start text-xs text-muted-foreground underline-offset-2 hover:underline"
        >
          Restablecer
        </button>
      ) : null}
    </div>
  )
}
